module.exports = __webpack_public_path__ + "static/media/1of3.05364ead.png";